import { render, staticRenderFns } from "./ChartFinanceSummaryBox.vue?vue&type=template&id=28a4c807&scoped=true"
import script from "./ChartFinanceSummaryBox.vue?vue&type=script&lang=js"
export * from "./ChartFinanceSummaryBox.vue?vue&type=script&lang=js"
import style0 from "./ChartFinanceSummaryBox.vue?vue&type=style&index=0&id=28a4c807&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a4c807",
  null
  
)

export default component.exports